import { useState, useCallback } from 'react';
import { useLenis } from 'lenis/react';

/**
 * Retorna `true` quando o scroll vertical supera `threshold` pixels.
 * Usa o `useLenis` para se integrar com o smooth scroll sem re-renders
 * excessivos (atualiza estado só quando cruza o threshold).
 */
export function useScrolled(threshold = 80): boolean {
  const [scrolled, setScrolled] = useState(false);

  const handler = useCallback(
    ({ scroll }: { scroll: number }) => {
      const isScrolled = scroll > threshold;
      setScrolled((prev) => (prev === isScrolled ? prev : isScrolled));
    },
    [threshold],
  );

  useLenis(handler);

  return scrolled;
}
